import { ElementRef, ViewChild } from '@angular/core';
import { TextinputBarComponent } from './textinput-bar/textinput-bar.component';
import { MainService } from './../../../Services/service.service';
import { ConversationService } from './../../../Services/conversationService';
import { ActivatedRoute, Router } from '@angular/router';
import { DTOConversation } from './../../../api/WickedApiClient';
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';



@Component({
  selector: 'vng-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ChatComponent {

  @ViewChild('chatComponent',{static:false}) public elementRef: ElementRef;

  private activeConversationId: number;

  @Output() submitClick = new EventEmitter<TextinputBarComponent>();

  @Input() showUserList: boolean = true;
  @Input() userListCollapsed: boolean = false;
  @Input() public acceptTermsEnable: boolean = false;
  
  @Input() public newConversationAdvId;
  newConv :boolean = false;

  public activeGroup: DTOConversation = null// dodane testowo na sztywno

  constructor(private mainService: MainService, private route: ActivatedRoute, private conversationService: ConversationService) {
    const urlId = this.route.snapshot.paramMap.get('id');
    this.activeConversationId = parseInt(urlId);
    if(urlId){
      this.mainService.showLoader();
    }
    this.getUrlConversation();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.getUrlConversation();
  }


  ngOnInit(){
    if(this.newConversationAdvId){
      this.newConv = true;
    }
  }

  getUrlConversation(){
    if(this.activeConversationId){
      this.conversationService.getConversation(this.activeConversationId).then(result => {
        this.activeGroup = result;
        this.mainService.hideLoader();
      });
    }else{
      this.activeGroup = null;
    }
  }

  activateGroup(group: DTOConversation){
    const newUrl = "conversations/"+group.conversationId;
    window.history.pushState({pageTitle:"conversations"},"", newUrl);

    this.activeGroup = group;
  }

  changesHelper: boolean = true;
  reloadMessages(conversation){
    this.activeGroup.messages=conversation.messages;
    this.conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(c => c.conversationMessageId));
    this.changesHelper= !this.changesHelper;
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    const lastMsgRef = document.querySelectorAll(".vng-chat-message:last-child")[0];
    if(lastMsgRef) lastMsgRef.scrollIntoView();
  }

  fireInitialConversationMessage(message){
    this.submitClick.emit(message);
  }
  

}

export interface Group {
  groupName: string, groupImageUrl: string, lastMessage: string
}